import { Employee } from "./Employees";

export class Common {
    id: string;
    active: boolean;
    created_at: Date;
    updated_at: Date;
    created_by: any;
    business_id: string;
    // pageValidation: Map<string, string[]> = new Map();
    pageValidation: any;
    local: any;

    creator: Employee;

}